import React from 'react';
import { Star, Quote } from 'lucide-react';
import SectionTitle from '../components/ui/SectionTitle';
import { reviews } from '../data/mock';

const AvisPage = () => {
  const averageRating = reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length;

  return (
    <main className="pt-20 min-h-screen bg-[#0E0E0E]">
      {/* Hero */}
      <section className="py-20 bg-[#1A1A1A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#F7C948]/10 border border-[#F7C948]/30 text-[#F7C948] text-sm font-medium mb-6">
              <Star size={16} className="fill-current" />
              Témoignages
            </div>
            <h1 className="font-display text-5xl md:text-6xl font-extrabold text-white mb-4">
              Avis Clients
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-8">
              Découvrez ce que nos clients pensent de Just'Une Dalle
            </p>

            {/* Rating Summary */}
            <div className="inline-flex items-center gap-4 bg-[#0E0E0E] rounded-2xl px-8 py-4 border border-[#F7C948]/20">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={24}
                    className={i < Math.round(averageRating) ? 'text-[#F7C948] fill-[#F7C948]' : 'text-gray-600'}
                  />
                ))}
              </div>
              <div className="h-8 w-px bg-white/20" />
              <div>
                <span className="font-display text-3xl font-bold text-white">{averageRating.toFixed(1)}</span>
                <span className="text-gray-400 text-sm ml-2">/ 5</span>
              </div>
              <div className="h-8 w-px bg-white/20" />
              <span className="text-gray-400">{reviews.length} avis</span>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            {reviews.map((review, index) => (
              <div
                key={review.id}
                className="bg-[#1A1A1A] rounded-2xl p-6 border border-white/5 hover:border-[#F7C948]/20 transition-all duration-300 relative group"
              >
                {/* Quote icon */}
                <div className="absolute top-6 right-6 opacity-10 group-hover:opacity-20 transition-opacity duration-300">
                  <Quote size={48} className="text-[#F7C948]" />
                </div>

                {/* Rating */}
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={18}
                      className={i < review.rating ? 'text-[#F7C948] fill-[#F7C948]' : 'text-gray-600'}
                    />
                  ))}
                </div>

                {/* Content */}
                <p className="text-gray-300 leading-relaxed mb-6 relative z-10">
                  "{review.text}"
                </p>

                {/* Author */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-[#F7C948]/20 rounded-full flex items-center justify-center">
                      <span className="text-[#F7C948] font-bold text-lg">
                        {review.author.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="text-white font-semibold">{review.author}</p>
                      <p className="text-gray-500 text-sm">Client vérifié</p>
                    </div>
                  </div>
                  <span className="text-gray-500 text-sm">{review.date}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 bg-[#1A1A1A]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="font-display text-4xl md:text-5xl font-bold text-[#F7C948] mb-2">5/5</div>
              <p className="text-gray-400">Note moyenne</p>
            </div>
            <div className="text-center">
              <div className="font-display text-4xl md:text-5xl font-bold text-[#F7C948] mb-2">100%</div>
              <p className="text-gray-400">Satisfaction</p>
            </div>
            <div className="text-center">
              <div className="font-display text-4xl md:text-5xl font-bold text-[#F7C948] mb-2">{reviews.length}+</div>
              <p className="text-gray-400">Avis positifs</p>
            </div>
            <div className="text-center">
              <div className="font-display text-4xl md:text-5xl font-bold text-[#F7C948] mb-2">XXL</div>
              <p className="text-gray-400">Portions</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-4">
            Vous aussi, venez nous découvrir !
          </h2>
          <p className="text-gray-400 mb-8">
            Rejoignez nos clients satisfaits et goûtez à notre street-food gourmande
          </p>
          <a
            href="https://www.google.com/search?q=just+une+dalle+malafretaz+avis"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-flex items-center gap-2"
          >
            <Star size={20} />
            Laisser un avis sur Google
          </a>
        </div>
      </section>
    </main>
  );
};

export default AvisPage;
